import { LimitPopup } from 'entities/tour/ui'

import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib/useDialogBottomSheet'

import searchTour from '../models/search-tour/search-tour'

export const useTourLimits = () => {
  const { openDialog, closeDialog } = useDialogBottomSheet()
  const isTourLimited = searchTour.getIsTourLimited()

  const checkHasLimitedTour = (callback: () => void) => {
    if (isTourLimited) {
      openDialog({
        isDialog: false,
        child: <LimitPopup closeDialog={closeDialog} />,
      })
    } else {
      callback()
    }
  }

  return {
    checkHasLimitedTour,
    isTourLimited,
  }
}
